import React, { useEffect, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import SubSideBar from "../../../component/organisms/subSideBar";
import SubSideBarItem from "../../../component/molecules/subSideBarItem";
import { route } from "../../../router/route";
import Table from "../../../component/atoms/layout/table/table";
import Td from "../../../component/atoms/layout/table/td";
import Th from "../../../component/atoms/layout/table/th";
import Tr from "../../../component/atoms/layout/table/tr";
import TableText from "../../../component/atoms/text/table/tableText";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import TableCount from "./../../../component/molecules/tableCount";
import SearchBar from "./../../../component/atoms/input/searchBar";
import ExcelBtn from "./../../../component/atoms/button/excelBtn";
import TableFilter from "./../../../component/atoms/layout/table/tableFilter";
import moment from "moment";
import ProductApi from "../../../api/product.api";
import { errorHandler } from "../../../util/errorHandler";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import Modal from "../../../component/templates/Modal";

const ShoppingMembershipProductLms = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars

  // ---------- 쓰기 권한체크 ---------- //
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.shopping_membership_product)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    getProductList();
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 상품 관련 ---------- //
  // 상품 리스트 관련 상태
  const [productList, setProductList] = useState([]);

  // 상품 리스트 가져오기
  const getProductList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        saveStatus: "Y",
        merchType: "MEMBERSHIP",
      };

      if (keyword) {
        data.keyword = keyword;
      }

      const response = (await ProductApi.getListProduct(data)).data.data;

      setProductList(
        [...response.content].map((item, index) => {
          return {
            ...item,
            numbering: response.content.length - index, // 역순으로 부여
          };
        })
      );
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 판매 상태 관련 ---------- //
  const [filterOpen, setFilterOpen] = useState(-1);
  const [saleStatusId, setSaleStatusId] = useState(null);
  const [saleStatus, setSaleStatus] = useState(null);
  const [saleStatusModalTitle, setSaleStatusModalTitle] = useState("");
  const [saleStatusModalOpen, setSaleStatusModalOpen] = useState(false);

  const activationFunc = async () => {
    try {
      const data = {
        activation: saleStatus,
      };
      await ProductApi.updateActivationProduct(saleStatusId, data);
      toast(toastMsg.create);
      setFilterOpen(-1);
      setSaleStatusModalOpen(false);
      getProductList();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 카테고리 영역 */}
        <SubSideBar title="카테고리">
          <SubSideBarItem
            selected={false}
            onClick={() => {
              navigate(route.shopping_membership_product);
            }}
          >
            수강권
          </SubSideBarItem>
          <SubSideBarItem
            selected={true}
            onClick={() => {
              navigate(route.shopping_membership_product_lms);
            }}
          >
            멤버십 상품 전자책
          </SubSideBarItem>
        </SubSideBar>

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>멤버십 상품관리</TableTitle>
          {/* 테이블 상단 영역 */}
          <TableTop>
            <TableCount text={"상품"} count={productList.length || 0} />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <SearchBar
                value={keyword}
                placeholder={"상품명"}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    if (keyword !== "") {
                      navigate(
                        `${route.shopping_membership_product_lms}?page=1&keyword=${keyword}`,
                        {
                          replace: true,
                        }
                      );
                    } else {
                      navigate(route.shopping_membership_product_lms, {
                        replace: true,
                      });
                    }
                  }
                }}
                onClick={() => {
                  navigate(
                    `${route.shopping_membership_product_lms}?page=1&keyword=${keyword}`,
                    {
                      replace: true,
                    }
                  );
                }}
              />
              {/* <ExcelBtn /> */}
            </div>
          </TableTop>

          {/* 테이블 영역 */}
          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* No */}
              <col width="71px" />
              {/* 상품명 */}
              <col width="347px" />
              {/* 목차 */}
              <col width="283px" />
              {/* 상태 */}
              <col width="125px" />
              {/* 등록일 */}
              <col width="113px" />
              {/* 수정일 */}
              <col width="105px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "23px" }}>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    No
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    상품명
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    목차
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    상태
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    등록일
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    수정일
                  </TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {productList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "72px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "23px" }}>
                      <TableText>{item.numbering}</TableText>
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          maxWidth: "319px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          if (isWriteAuthority) {
                            navigate(
                              `${route.shopping_membership_product_lms_detail}/${item.id}`
                            );
                          } else {
                            toast(
                              <>
                                편집 권한이 없습니다.
                                <br />
                                최고관리자에게 문의하세요.
                              </>
                            );
                          }
                        }}
                      >
                        {item?.title || ""}
                      </TableText>
                    </Td>

                    <Td>
                      <img
                        src="/assets/admin/icons/ico_curriculum.svg"
                        alt="목차/커리큘럼"
                        style={{
                          width: 21,
                          height: 20,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          navigate(
                            `${route.shopping_product_chapter}/${item.id}`
                          );
                        }}
                      />
                    </Td>
                    <Td>
                      <TableFilter
                        style={{
                          width: "fit-content",
                          gap: 10,
                        }}
                        onClick={() => {
                          if (!isWriteAuthority) {
                            toast(
                              <>
                                편집 권한이 없습니다.
                                <br />
                                최고관리자에게 문의하세요.
                              </>
                            );
                            return;
                          }

                          filterOpen === index
                            ? setFilterOpen(-1)
                            : setFilterOpen(index);
                        }}
                        isOpen={filterOpen === index}
                        selectedValue={item.activation}
                        list={[
                          {
                            value: true,
                            title: "판매중",
                            onClick: () => {
                              setSaleStatusId(item.id);
                              setSaleStatus(true);
                              setSaleStatusModalTitle("판매중");
                              setSaleStatusModalOpen(true);
                            },
                          },
                          {
                            value: false,
                            title: "숨김",
                            onClick: () => {
                              setSaleStatusId(item.id);
                              setSaleStatus(false);
                              setSaleStatusModalTitle("숨김");
                              setSaleStatusModalOpen(true);
                            },
                          },
                        ]}
                      />
                    </Td>
                    <Td>
                      <TableText>
                        {moment(item.createdAt).format("YYYY-MM-DD")}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {moment(item.createdAt).format("YYYY-MM-DD")}
                      </TableText>
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
        </DetailPageLayout>
      </MainLayout>

      {/* 판매 상태 변경 모달 */}
      {saleStatusModalOpen ? (
        <Modal
          title={`${saleStatusModalTitle} 하시겠습니까?`}
          setModalOpen={setSaleStatusModalOpen}
          onClick={() => {
            activationFunc();
          }}
        />
      ) : null}
    </>
  );
};

export default ShoppingMembershipProductLms;
